import { useTranslation } from 'react-i18next'
import { Skeleton, Typography } from '@mui/material'

import { useStyles } from './styles'
import { HelperWrapper } from 'src/components/helper-wrapper'
import { CalendarIcon } from 'src/assets/icons/v2/CalendarIcon'
import { DateCalendarIcon } from 'src/assets/icons/v2/DateCalendarIcon'
import { DiscountIcon } from 'src/assets/icons/v2/DiscountIcon'

interface IProps {
  monthlyFee?: string | null
  yearlyFee?: string | null
  yearlyCalculation?: string
  discount?: string
}

export const PlanPrices = (props: IProps) => {
  const [t] = useTranslation()
  const classes = useStyles()

  return (
    <div className={classes.planPricesWrapper}>
      <div>
        <Typography className={classes.planPriceTitle}>
          <DateCalendarIcon size={20} />
          <HelperWrapper t="subscribtion-monthly-title" />
        </Typography>
        <div className={classes.planPriceWrapper}>
          {props.monthlyFee ? (
            <span className={classes.planPrice}>{props.monthlyFee}</span>
          ) : (
            <Skeleton variant="text" height="26px" />
          )}
        </div>
      </div>

      <div>
        <Typography className={classes.planPriceTitle}>
          <CalendarIcon size={20} />
          <HelperWrapper t="subscribtion-setup-title" />
        </Typography>
        <div className={classes.planPriceWrapper}>
          {props.monthlyFee ? (
            <span className={classes.planPrice}>{props.yearlyFee}</span>
          ) : (
            <Skeleton variant="text" height="26px" />
          )}
          {props.yearlyCalculation && (
            <span className={classes.calculationText}>
              ({props.yearlyCalculation} /{t('month-short-text.v')})
            </span>
          )}
        </div>
      </div>
      {props.yearlyCalculation && (
        <div>
          <Typography className={classes.planPriceTitle}>
            <DiscountIcon size={20} />
            <span>{props.discount}</span>
          </Typography>
        </div>
      )}
    </div>
  )
}
